import React, {Component} from 'react';
import Board from 'react-trello';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { Table, Tooltip, OverlayTrigger } from 'react-bootstrap';

import $ from 'jquery';
window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');

var session = sessionStorage.getItem('health_facilities_name');
const Config = require('../../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";

class BoardList extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.filtering = this.filtering.bind(this);

		this.state = {
			send:0,
			start:0,
			end:0,
			incidents:0,
			view_all:false,
			filter:"",
			list:[]
		}
	}

	componentWillMount(){
		this._mounted = true;
		var search = this.props.match.url.replace('/', '');

		//Actualizar listado por mensaje del servidor
      	_hub = $.hubConnection(ChatUrl, {
        	useDefaultPath: false
      	});

      	ChatProxy = _hub.createHubProxy('ChatHub');
      	ChatProxy.getItems = this.getList;

      	ChatProxy.on("addNewMessageToPage", function(name, message) {
	        if(message === "refresh_hemo_board" && search.indexOf('board_list') !== -1){
	          this.getItems();
	        }
      	});

      	_hub.start()
      	.done(function() {
        	console.log("Connected to Signalr Server");
      	})
      	.fail(function() {
        	console.log("failed in connecting to the signalr server");
      	});

      	
	}

	componentWillUnmount(){
		this._mounted = false;
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		this.getList();
		setInterval(()=>{ this.getList(); }, 30000);
	}

	getList(){
		
		fetch(Config.default.apiGateway.URL+'unit_delivered/get_list_dashboard_v2?hf_id=1&show_all='+this.state.view_all,{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				response.units.map((unit, i)=>{

					var color = unit.color === 'RED' ? '#ff8993' : 
									unit.color === 'WHITE' ? '#fff' : 
									unit.color === 'YELLOW' ? '#f4dc64' : '#71e471';

					if(unit.column === 1){
						unit.color_send = color;
					}else {
						unit.color_send = '#fff';
					}

					if(unit.column === 2){
						unit.color_start = color
					}else {
						unit.color_start = '#fff';
					}

					if(unit.column === 3){
						unit.color_end = color
					}else {
						unit.color_end = '#fff';
					}
					
					unit.font_send = 'black';
					unit.font_start = 'black';
					unit.font_end = 'black';

				});


				this.setState({
					send:response.tot_enviadas,
					start:response.tot_trans_ini,
					end:response.tot_trans_end,
					incidents:response.tot_incidents,
					list: response.units
				});


			}
		});
	}

	handleChange(e){
		var value = e.target.value;
		if(e.target.type === 'checkbox'){
			this.setState({[e.target.name]: e.target.checked ? true : false});
			setTimeout(()=>{
				this.getList();
			}, 500);

		}else{
			this.setState({[e.target.name]: value});
		}
		
	}

	filtering(item){
		var aux = item.unit_number+' '+item.number+' '+item.patient;

		if(aux.indexOf(this.state.filter.toUpperCase()) !== -1){
			return true;
		}else{
			return false;
		}
	}

	render() {
	  	const {t} = this.props;
	    return (
	    	<div className="col-xs-12">
	    		<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						{t('sidebar.nav.patients.board')} - v2
					</h5>
				</div>
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<input name="filter" id="filter" value={this.state.filter} onChange={this.handleChange} className="form-control"
							placeholder="Unidad ó Paciente" />
					</div>
					<div className="col-xs-12 col-sm-1">
						<input type="checkbox" name="view_all" id="view_all" value={this.state.view_all} onChange={this.handleChange} />
						<span className="span-min"> Ver Todos</span>
					</div>
					<div className="col-xs-12 col-sm-7">
						<span className="title-result-stats">Total Enviadas: </span><span className="result-stats"> {this.state.send}</span>
						<span className="title-result-stats">Transfusiones Iniciadas: </span><span className="result-stats"> {this.state.start}</span>
						<span className="title-result-stats">Transfusiones Finalizadas: </span><span className="result-stats"> {this.state.end}</span>
						<span className="title-result-stats">Con incidentes: </span><span className="result-stats"> {this.state.incidents}</span>
					</div>
	    		</div>

	    		<div className="col-xs-12">
	    			<Table responsive hover>
	    				<thead>
	    					<tr>
	    						<th>Unidad</th>
	    						<th>Componente</th>
	    						<th>Servicio</th>
	    						<th>Expediente</th>
	    						<th>Paciente</th>
	    						<th>Envío</th>
	    						<th>Inicio Transfusión</th>
	    						<th>Fin Transfusión</th>
	    						<th>Incidente</th>
	    					</tr>
	    				</thead>
	    				<tbody>
	    					{this.state.list.map((l, i)=>(
	    						this.filtering(l) ?
		    						<tr key={i}>
		    							<td>{l.unit_number}</td>
			    						<td>{l.component}</td>
			    						<td>{l.service}</td>
			    						<td>{l.number}</td>
			    						<td>{l.patient}</td>
			    						<td style={{background:l.color_send, color:l.font_send}}>
			    							{l.hour_delivered !== null ? moment(l.hour_delivered).format('DD/MM/YYYY HH:mm') : ''}
			    						</td>
			    						<td style={{background:l.color_start, color:l.font_start}}>
			    							{l.hour_start !== null ? moment(l.hour_start).format('DD/MM/YYYY HH:mm') : ''}
			    						</td>
			    						<td style={{background:l.color_end, color:l.font_end}}>
			    							{l.hour_end !== null ? moment(l.hour_end).format('DD/MM/YYYY HH:mm') : ''}
			    						</td>
			    						<td>
			    							<OverlayTrigger
										      	key={i}
										      	placement={'left'}
										      	overlay={
										        	<Tooltip >
										          		{l.incidents}
										        	</Tooltip>
										      	}>
										      	<span>{l.incidents.length > 20 ? l.incidents.slice(0,20)+'...' : l.incidents}</span>
										    </OverlayTrigger>
			    						</td>
		    						</tr>
		    					: null		
	    					))}
	    				</tbody>
	    			</Table>
	    		</div>
	    	</div>
	    ) 
    	
  	}
}
export default translate('translations')(BoardList);